import { getJsonP } from "../helpers/scripts";
import { GeolocationData } from "../types/common";
import { LocationPromise } from "../types/location";

const service = (): LocationPromise =>
  getJsonP(__LOCATION_API, "YlePlayerLocation");

export const getCurrentGeolocation = async (
  locationService: () => LocationPromise = service
): Promise<GeolocationData> => {
  try {
    const { country_code = "FI", is_portability_region } =
      await locationService();

    return {
      countryCode: country_code,
      isPortabilityRegion:
        is_portability_region === undefined || is_portability_region
    };
  } catch (e) {
    console.error("Locations API error: ", e);
    return { countryCode: "FI", isPortabilityRegion: true };
  }
};
